import { Compass, Footprints, Users } from "lucide-react";
import { Reveal } from "@/components/site/Motion";
import { SectionHead } from "@/components/site/SectionHead";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";
import { CoachingScope } from "@/components/site/CoachingScope";

const FEATURES = [
  { icon: Compass, title: "Clarity & Mindset Alignment", text: "Reflect on recurring thought patterns, identify everyday distractions, and align your mindset with your personal and professional goals." },
  { icon: Footprints, title: "Sustainable Habit Change", text: "Transition from stagnant routines to an active, vital lifestyle through practical, grounded adjustments in your daily habits and rhythms." },
  { icon: Users, title: "Presence & Relationships", text: "Reconnect with your intuition, strengthen your personal presence, and explore how you communicate and set boundaries at home, at work and socially." },
];

export const CoachingSection = () => (
  <section id="coaching" className="scroll-mt-28 border-t border-[#e4dacb] py-24 md:scroll-mt-32 md:py-32" data-testid="coaching-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
      <div className="grid gap-8 lg:grid-cols-[0.95fr_1.05fr] lg:items-start lg:gap-20">
        <SectionHead size="large" eyebrow="Available now • Private 1:1 Coaching"
          title={<><span className="coaching-numerals">1:1</span>{" "}Personal &amp; Lifestyle Coaching</>}
          text="Bespoke, one-on-one sessions tailored to where you are right now." />
        <Reveal className="space-y-5 text-[1.0625rem] leading-[1.8] text-[#5d544c] sm:text-lg">
          <p>While the structured 21-day group journey is a guided map through all five layers, our primary
            offering today is private 1:1 coaching with Sheetal. These personalized sessions create a quiet,
            dedicated space to work directly on your specific life goals, daily habits, career transitions,
            and personal blocks.</p>
          <p>Together, we work closely to facilitate sustainable behavior change, supporting you in
            building daily habits for a more active, purposeful and balanced life.</p>
        </Reveal>
      </div>
      <div className="mt-12 grid gap-5 md:grid-cols-3 md:gap-6">
        {FEATURES.map(({ icon: Icon, title, text }) => (
          <Reveal key={title} className="rounded-[1.75rem] border border-[#e4dacb] bg-[#fffaf3] p-7 sm:p-8">
            <Icon aria-hidden="true" className="h-7 w-7 text-[#7a5615]" strokeWidth={1.25} />
            <h3 className="font-display mt-7 text-[2rem] font-medium leading-tight text-[#221e1b]">{title}</h3>
            <p className="mt-4 text-base leading-[1.75] text-[#5d544c]">{text}</p>
          </Reveal>
        ))}
      </div>
      <div className="mt-10 flex justify-center sm:justify-start">
        <WhatsAppButton testId="coaching-whatsapp-btn">Inquire About 1:1 Coaching on WhatsApp</WhatsAppButton>
      </div>
      <CoachingScope />
    </div>
  </section>
);
